import { call } from './utils';

//****BIKES CRUD

//bike creation
export const sendEmail = async (data, accessToken) =>
  await call({
    url: '/api/send-email',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
//bike update
export const sendNotification = async (data, accessToken) =>
  await call({
    url: '/api/send-notification',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
